import Vue from 'vue'
import GanttElastic from "gantt-elastic";
import Header from "gantt-elastic-header"; // if you want standard header (npm i -s gantt-elastic-header)

Vue.component('gantt-elastic', GanttElastic)
Vue.component('gantt-elastic-header', Header)
